import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, Switch } from 'react-router-dom';
import SwingSubmittalsListPage from './SwingSubmittalsListPage';
import SwingSubmittalReviewPage from './SwingSubmittalReviewPage';
import querystring from 'querystring';
import { fetchSubmittalsHistory, fetchSubmittalsPendingReview } from './actions';
import Loading from '../common/components/Loading';

class GolfSchools extends Component {
  componentDidMount() {
    const { search } = this.props.location;
    const qs = search ? querystring.parse(search.slice(1)) : {};

    this.props.dispatch(this.getFetchAction(qs)());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.search !== this.props.location.search) {
      const { search } = this.props.location;
      const qs = search ? querystring.parse(search.slice(1)) : {};

      this.props.dispatch(this.getFetchAction(qs)());
    }
  }

  getFetchAction(qs) {
    if (qs.viewHistory) {
      const { viewHistory, ...getParams } = qs;
      return fetchSubmittalsHistory.bind(this, getParams);
    } else {
      return fetchSubmittalsPendingReview;
    }
  }

  render() {
    const { match, loaded } = this.props;

    if (!loaded) {
      return <Loading />;
    }

    return (
      <Switch>
        <Route exact path={`${match.path}`} component={SwingSubmittalsListPage} />
        <Route exact path={`${match.path}/:id`} component={SwingSubmittalReviewPage} />
        <Redirect to={`${match.path}`} />
      </Switch>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const { search } = ownProps.location;
  const qs = search ? querystring.parse(search.slice(1)) : {};

  return {
    loaded:
      (qs.viewHistory && state.swingSubmittals.history.get('loaded')) ||
      (!qs.viewHistory && state.swingSubmittals.pendingReview.get('loaded')),
  };
};

export default connect(mapStateToProps)(GolfSchools);



// WEBPACK FOOTER //
// ./src/swing-submittals/SwingSubmittals.js